import CloseButtonIcon from "@components/Shared/CloseButtonIcon";
import styles from "./BoxVideoThumbnail.module.scss";
import ReactPlayer from "react-player";
import { getYouTubeThumbnailUrl } from "@helpers/youtube.helper";

interface IBoxVideoThumbnail {
  url: string;
  onRemove?: () => void;
  isPreview?: boolean;
  isYoutube?: boolean;
}

const BoxVideoThumbnail = ({
  url,
  onRemove,
  isPreview = false,
  isYoutube = false,
}: IBoxVideoThumbnail) => (
  <div
    className={`${styles.boxVideoThumbnail} ${
      isPreview ? styles.isPreview : ""
    }`}
  >
    {isYoutube ? (
      <img src={getYouTubeThumbnailUrl(url)} alt="YouTube thumbnail" />
    ) : (
      <video src={url} />
    )}

    {onRemove && <CloseButtonIcon onRemove={onRemove} />}
  </div>
);
export default BoxVideoThumbnail;
